<script lang="ts">import tooltip from './tooltip';
import { DEFAULTS as D } from './defaults';
let { content = null, target = D.target, placement = D.placement, shiftPadding = D.shiftPadding, offset = D.offset, delay = D.delay, constant = D.constant, classes = D.classes, middleware = D.middleware, onMount, onDestroy, html = D.html, block = false, children, as = 'div' } = $props();
</script>

<svelte:element
	this={as}
	class="svooltip-wrapper"
	class:block
	use:tooltip={{
		content,
		html,
		target,
		placement,
		shiftPadding,
		offset,
		delay,
		constant,
		classes,
		middleware,
		onMount,
		onDestroy
	}}
>
	{@render children()}
</svelte:element>
